module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGARDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGITAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1-50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS")]), _vm._v(" 1-50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#chap-001"
    }
  }, [_vm._v("The Blessed and the Wicked Psalm 1:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("The Lord’s Anointed King Psalm 2:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_vm._v("Prayer for Deliverance Psalm 3:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap4"
    }
  }, [_vm._v("Deliverance and Thanksgiving Psalm 4:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plea for Justice Psalm 5:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Healing Psalm 6:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God the Righteous Judge Psalm 7:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Glory of the Lord Psalm 8:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confidence in God Psalm 9:1-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plea for God’s Judgment Psalm 10:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust in the Lord Psalm 11:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Protection Psalm 12:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting on the Lord Psalm 13:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("None Seek God Psalm 14:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blameless Psalm 15:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Faithfulness to the Lord Psalm 16:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Protection Psalm 17:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thanksgiving Psalm 18:1-50")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Self-Revelation Psalm 19:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Victory Psalm 20:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thanksgiving for Victory Psalm 21:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lament in Suffering Psalm 22:1-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Protection Psalm 23:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Approaching God Psalm 24:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Forgiveness Psalm 25:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Vindication Psalm 26:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer of Devotion Psalm 27:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plea for Divine Assistance Psalm 28:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Power of God Psalm 29:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Healing Psalm 30:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Rescue Psalm 31:1-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confession and Forgiveness Psalm 32:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sovereignty of God Psalm 33:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for Deliverance Psalm 34:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plea for Divine Assistance Psalm 35:1-28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wicked and the Righteous Psalm 36:1-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trust in the Lord Psalm 37:1-40")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer in Sickness Psalm 38:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intimations of Mortality Psalm 39:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting Patiently Psalm 40:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Healing Psalm 41:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thirst for God Psalm 42:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope in God Psalm 43:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prayer for Victory Psalm 44:1-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Wedding Hymn Psalm 45:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Is Our Refuge Psalm 46:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Is Exalted Psalm 47:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beauty of Zion Psalm 48:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why Fear Death? Psalm 49:1-20")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Divine Judgment Psalm 50:1-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPENDIX")]), _vm._v(": E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITED")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCHES")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCRIPTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMELINE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRISTIC")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIOD")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHORS")]), _vm._v("/W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITORS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0